import React, { useState } from 'react';
import ACHWithdraw from './USDOptions/ACHWithdraw';
import WireWithdraw from './USDOptions/WireWithdraw';
import SwiftWithdraw from './USDOptions/SwiftWithdraw';

const WithdrawUSD = ({ onBack }) => {
   const [selectedMethod, setSelectedMethod] = useState(null);

   const handleMethodSelect = (method) => {
      setSelectedMethod(method);
   };

   const handleBack = () => {
      setSelectedMethod(null);
   };

   return (
      <>
         {!selectedMethod ? (
            <>
               {/* Título para la pantalla de selección de método */}
               <h3 className="ppt_form_title mb-5 text-center">Method of transfer</h3>
               <div className='ppt_deposit_ex text-center gap-3'>
                  <div
                     className='ppt_deposit_item anchor'
                     onClick={() => handleMethodSelect('ach')}
                  >
                     <div className='ppt_deposit_item_imgs'>
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_bank.svg'} alt="" />
                     </div>
                     <b>ACH</b>
                  </div>
                  <div
                     className='ppt_deposit_item anchor'
                     onClick={() => handleMethodSelect('wire')}
                  >
                     <div className='ppt_deposit_item_imgs'>
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_wire.svg'} alt="" />
                     </div>
                     <b>Wire</b>
                  </div>
                  <div
                     className='ppt_deposit_item anchor'
                     onClick={() => handleMethodSelect('swift')}
                  >
                     <div className='ppt_deposit_item_imgs'>
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_swift.svg'} alt="" />
                     </div>
                     <b>SWIFT</b>
                  </div>
               </div>
            </>
         ) : (
            <>
               {selectedMethod === 'ach' && <ACHWithdraw onBack={handleBack} />}
               {selectedMethod === 'wire' && <WireWithdraw onBack={handleBack} />}
               {selectedMethod === 'swift' && <SwiftWithdraw onBack={handleBack} />}
            </>
         )}
      </>
   );
};

export default WithdrawUSD;